/*
 * Copyright (C) Fraunhofer IESE 2021-2025 - Mher Ter-Tovmasyan
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

export const draftPageEn = {
  pageHead: {
    municipality: {
      title: "Municipalities",
      subtitle: "Get in touch and become part of {{appName}}.",
      description:
        "We are pleased that you want to become part of {{appName}}! In the first step, contact us by filling out and submitting the contact form.",
    },
    solutionProvider: {
      title: "Solution<wbr>Provider",
      subtitle: "Get in touch and become part of {{appName}}.",
      description:
        "We are pleased that you want to become part of the {{appName}} marketplace! In the first step, contact us by filling out and submitting the contact form.",
    },
    publicAuthorities: {
      title: "Other Public Authorities",
      subtitle: "Get in touch and become part of {{appName}}.",
      description:
        "We are pleased that you want to become part of {{appName}}! In the first step, contact us by filling out and submitting the contact form.",
    },
  },
  success: {
    title: "Your request has been sent successfully!",
    content:
      "Thank you\n Your request is now being reviewed. You will receive an email with further information in the coming days.",
    confirm: "All Clear!",
  },
  name: {
    municipality: {
      label: "Municipality Name*",
      placeholder: "Search for municipality",
      notFoundLabel: "Municipality was not found.",
      loadingLabel: "Municipalities are being loaded.",
      minSearchLabel:
        "Please enter more than two characters to start the search",
      error:
        "This municipality is already registered. In case of unclear jurisdiction, please use our <0>contact form</0>.",
    },
    solutionProvider: {
      label: "Company Name*",
      placeholder: "Company Name",
      error:
        "This company seems to already be registered. In case of unclear jurisdiction, please use our <0>contact form</0>.",
    },
    publicAuthorities: {
      label: "Organization Name*",
      placeholder: "Name of the authority, association, etc.",
      error:
        "This organization seems to already be registered. In case of unclear jurisdiction, please use our <0>contact form</0>.",
    },
  },
  additionalInformation: {
    label: "Organization Type*",
    placeholder: "Please select",
  },
  solutionInformation: {
    label: "Offered Solution*",
    placeholder: "The solution that should be offered on the marketplace",
  },
  website: {
    label: "Website",
    placeholder: "URL to your website",
  },
  contactPerson: {
    label: "Contact Person Name*",
    placeholder: "First and last name of the contact person",
  },
  contactEmailAddress: {
    label: "Contact Person Email Address*",
    info: {
      municipality:
        "This email will be invited for the administration of the municipality.",
      solutionProvider:
        "This email will be invited for the administration of the solution provider organization.",
      publicAuthorities:
        "This email will be invited for the administration of the organization.",
    },
    placeholder: "Contact person email address",
  },
  memberEmailAddresses: {
    label: "Additional Member Emails",
    placeholder: "Email addresses of additional members",
    email: "Email Address",
    add: "Add Email Address",
    addMore: "Add Another Email Address",
    remove: "Remove Email Address",
  },
  formError: {
    name: {
      municipality: "Please enter the municipality name.",
      solutionProvider: "Please enter the company name.",
      publicAuthorities: "Please enter the organization name.",
    },
    contactEmailAddress: "Email is a required field.",
    invalidEmail: "Please enter a valid email address.",
    contactPerson: "Please enter the contact person name.",
    solutionInformation:
      "Please provide information about the offered solution.",
    type: "Please select an organization type.",
    invalidWebsite: "Please enter a valid URL.",
  },
  send: "Send",
};
